<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t('Definitions') }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                :disabled="!sayfayetki.Save"
                @click="addParameters()"
                flat
              >
                <span class="hidden-sm-and-down"> {{$t('save_button')}} </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">{{$t('save_button')}}</span>
            </v-tooltip>
        
          </v-toolbar>
        </v-flex>

        <v-flex xs12 sm12 md12>
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex pb-3 xs12 sm12 md12>
                <v-card light style="max-height: 600px">
                  <v-card-title primary title>
                    <v-flex xs12 sm12 pt-2 md12>
                      <v-layout row wrap class="project overdue">
                        <v-toolbar flat="" size="120px" dark color="white">
                          <v-toolbar-title>
                            <span class="headline black--text font-weight-bold">
                              {{ $t("General-Parameters") }}
                            </span>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                      </v-layout>
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md4>
                        <tarihim
                          :v-bind="parameters.PeriodStart"
                          v-model="parameters.PeriodStart"
                          :etiket="$t('Term-Start')"
                          :aktifmi="false"
                        >
                        </tarihim>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <tarihim
                          :v-bind="parameters.PeriodEnd"
                          v-model="parameters.PeriodEnd"
                          :etiket="$t('Term-End')"
                          :aktifmi="false"
                        >
                        </tarihim>
                      </v-flex>
                       <v-flex xs12 sm12 md4>
                        <tarihim
                          :v-bind="parameters.LockDate"
                          v-model="parameters.LockDate"
                          etiket="Kilit Tarihi (Bu Tarih ve Öncesine Kayıt Yazılamaz.)"
                          :aktifmi="false"
                         
                        >  
                        </tarihim>
                       
                      </v-flex>
                      
                      <v-flex xs12 sm12 md6>
                        <v-switch
                          :label="$t('Uniform-Accounting-Model')"
                          v-model="parameters.SingleOrderAccounting"
                          :disabled="true"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <v-switch
                          label="Bilet Satış Entegrelerinde Satır Açıklamalarına Fatura No Basılsın"
                          v-model="parameters.SetInvoiceNumberToExplanation1"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <v-switch
                          label="Fiş Silindiğinde Entegresi Kaldırılsın"
                          v-model="parameters.RemoveIntegrationOnRecieptDelete"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <v-switch
                          label="Tahsilat Entegrelerinde Fiş Genel ve Satır Açıklamalarında Fatura Numarası Belirtilsin "
                          v-model="parameters.SetInvoiceNoOnRecieptTitleAndLineExp"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <v-switch
                          label="Cari Hareket, Tahsil Hareket ve Tediye Hareket Entegrelerinde Fiş Genel ve Satır Açıklamalarına, Varsa Fatura Numarası Eklensin "
                          v-model="parameters.SetInvoiceNoOnCariTransactionIntegration"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-switch
                          label="Maliyet Entegrasyonlarında, Acentadan Alınan Biletlerde, Önizleme filtrelerinde Satınalma Fatura Tarihi kullanılsın, Oluşan Fişlere ve Satır Açıklamalarına Satınalma Fatura Bilgileri Eklensin "
                          v-model="parameters.UsePurchaseInvoiceInfoForTicketsForAgencyInCostIntegration"
                        ></v-switch>
                      </v-flex> 
                       <v-flex xs12 sm12 md12>
                        <v-switch
                          label="Entegrasyon İşleminden Sonra Oluşan Fişleri Her Sayfaya 1 Fiş Gelecek Şekilde Yazdır."
                          v-model="parameters.PrintPageByPageLaterIntegration"
                        ></v-switch>
                      </v-flex> 
                      <v-flex xs12 sm12 md12>
                        <v-select
                          v-model="parameters.CurrentAccountCompanyCode"
                          :label="$t('Current-Account-Company-No')"
                          :items="currenctCompanies"
                          item-text="SirketUnvani"
                          item-value="SirketKodu"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <v-layout row wrap>
                          <v-flex
                            xs12
                            sm12
                            md12
                            v-if="parameters.SingleOrderAccounting"
                          >
                            <v-layout row wrap justify-center>
                              <v-flex xs2 sm1 md1>
                                <v-text-field
                                  mask="#"
                                  v-model="tekduzen1"
                                  solo
                                >
                                </v-text-field>
                              </v-flex>
                              <v-flex xs2 sm1 md1 class="headline pl-3 pt-3">
                                +
                              </v-flex>
                              <v-flex xs2 sm1 md1 align-center>
                                <v-text-field
                                  mask="#"
                                  v-model="tekduzen2"
                                  solo
                                >
                                </v-text-field>
                              </v-flex>
                              <v-flex xs2 sm1 md1 class="headline pl-3 pt-3">
                                +
                              </v-flex>

                              <v-flex xs2 sm1 md1>
                                <v-text-field
                                  mask="#"
                                  v-model="tekduzen3"
                                  solo
                                >
                                </v-text-field>
                              </v-flex>
                              <v-flex xs2 sm1 md1 class="headline pl-3 pt-3">
                                +
                              </v-flex>

                              <v-flex xs2 sm1 md1>
                                <v-text-field
                                  mask="#"
                                  v-model="tekduzen4"
                                  solo
                                >
                                </v-text-field>
                              </v-flex>
                              <v-flex xs2 sm1 md1 class="headline pl-3 pt-3">
                                +
                              </v-flex>

                              <v-flex xs2 sm1 md1>
                                <v-text-field
                                  mask="#"
                                  v-model="tekduzen5"
                                  solo
                                >
                                </v-text-field>
                              </v-flex>
                              <v-flex xs2 sm1 md1 class="headline pl-3 pt-3">
                                +
                              </v-flex>
                              <v-flex xs2 sm1 md1>
                                <v-text-field
                                  mask="#"
                                  v-model="tekduzen6"
                                  solo
                                >
                                </v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <!-- <v-text-field
                          :disabled="!parameters.SingleOrderAccounting"
                          v-model="parameters.SingleOrderPattern"
                          label="Tek Düzen Muhasebe Modeli"
                          append-icon="info"
                          @click:append="dialogInfo = !dialogInfo"
                          mask="#+#+#+#+#+#"
                          return-masked-value 
                        ></v-text-field> -->
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-card>
    <v-dialog v-model="dialogInfo" persistent max-width="450px">
      <v-card color="white">
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Bilgi</v-toolbar-title>
          </v-toolbar>
        </v-flex>

        <v-flex pa-2 xs12 sm12 md12>
          <p class="body-2 pa-2">
            {{ $t('Uniform-Accounting-Model-For-example') }}  {{ $t('If-the-accounting-code') }}
          </p>
        </v-flex>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat @click.native="dialogInfo = false"
            >{{$t('Close')}}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tarihim from "@/components/app/customcomp/tarihim.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "@/api/auth";

export default {
  name: "muhasebe-parametreler",
  data() {
    return {
      numberRule: (v) => {
        if (!v.trim()) return true;
        if (!isNaN(parseFloat(v)) && v >= 1 && v <= 9) return true;
        return "Number has to be between 0 and 999";
      },
      maskValue: null,
      dialogInfo: false,
      parameters: {
        ID: 0,
        CompanyID: 0,
        PeriodStart: null,
        PeriodEnd: null,
        SingleOrderAccounting: false,
        SingleOrderPattern: null,
        CurrentAccountCompanyCode: 0,
        SetInvoiceNumberToExplanation1:false,
        RemoveIntegrationOnRecieptDelete:false,
        SetInvoiceNoOnRecieptTitleAndLineExp:false,
        SetInvoiceNoOnCariTransactionIntegration:false,
        UsePurchaseInvoiceInfoForTicketsForAgencyInCostIntegration:false,
        PrintPageByPageLaterIntegration:false,
        LockDate:null,
      },
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      tekduzen1: null,
      tekduzen2: null,
      tekduzen3: null,
      tekduzen4: null,
      tekduzen5: null,
      tekduzen6: null,
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      currenctCompanies: [],
    };
  },
  methods: {
    preparePattern(val, tip) {
      //tip 1: ilk deger  onceki kayit sifirlaniyor.
      //tip 2: son deger + isareti eklenmiyor.
      if (val != null) {
        if (tip == 1) {
          this.parameters.SingleOrderPattern = val + "+";
        } else if (tip == 2) {
          this.parameters.SingleOrderPattern += val;
        } else {
          this.parameters.SingleOrderPattern += val + "+";
        }
      }
    },
    addParameters() {
      this.loadingvmodel=true;
      this.preparePattern(this.tekduzen1, 1);
      this.preparePattern(this.tekduzen2);
      this.preparePattern(this.tekduzen3);
      this.preparePattern(this.tekduzen4);
      this.preparePattern(this.tekduzen5);
      this.preparePattern(this.tekduzen6, 2);

      var controlZeroValue = this.parameters.SingleOrderPattern.search(0);
      if (controlZeroValue != -1) {
        this.text1 = this.$t('Unified-Accounting-System-Does-not-Include')
        this.snackbar = true;
        this.loadingvmodel=false;
        return false;
      }

      if (this.parameters.SingleOrderAccounting) {
        if (this.parameters.SingleOrderPattern == null) {
          this.text1 = this.$t('Unified-Accounting-System-Does-not-Include-Blank-Fields');
          this.snackbar = true;
          this.loadingvmodel=false;
          return false;
        } else {
          var TekDuzenKod = this.parameters.SingleOrderPattern.split("+");
          if (!TekDuzenKod[0]) {
            this.text1 = this.$t('Uniform-Accounting-Model-at-least');
            this.snackbar = true;
            this.loadingvmodel=false;
            return false;
          } else if (!TekDuzenKod[1]) {
            this.text1 = this.$t('Uniform-Accounting-Model-at-least');
            this.snackbar = true;
            this.loadingvmodel=false;
            return false;
          } else if (TekDuzenKod[1].length == 0) {
            this.text1 = this.$t('Uniform-Accounting-Model-at-least');
            this.snackbar = true;
            this.loadingvmodel=false;
            return false;
          }
        }
      }

      this.parameters.CompanyID = this.credentials.MuhasebeSirketNo;
      this.$http
        .post(
          auth.API_URL + "api/AccountingParameters/AccountingParametersSave",
          this.parameters,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
             this.text1 = this.$t(response.body.ResponseMessage);
            this.snackbar = true;
          
             setTimeout(() => {
    window.location.reload();
  }, 2000);
    this.loadingvmodel=false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingParametersSave";
              this.snackbar = true;
              this.loadingvmodel=false;
            } else {
              this.text1 = "Service Unavailable-AccountingParametersSave";
              this.snackbar = true;
              this.loadingvmodel=false;
            }
          }
        );
    },
    LoadParameters() {
      var params = {
        ID: 0,
        CompanyID: this.credentials.MuhasebeSirketNo,
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingParameters/AccountingParametersLoad",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.SingleOrderAccounting) {
              var patternValue = response.body.SingleOrderPattern.split("+");
              for (let index = 0; index < patternValue.length; index++) {
                const element = patternValue[index];
                switch (index) {
                  case 0:
                    this.tekduzen1 = element;
                    break;
                  case 1:
                    this.tekduzen2 = element;
                    break;
                  case 2:
                    this.tekduzen3 = element;
                    break;
                  case 3:
                    this.tekduzen4 = element;
                    break;
                  case 4:
                    this.tekduzen5 = element;
                    break;
                  case 5:
                    this.tekduzen6 = element;
                    break;
                  default:
                    break;
                }
              }
            }

            this.parameters = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingParametersLoad";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-AccountingParametersLoad";
              this.snackbar = true;
            }
          }
        );
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      this.credentials.MuhasebeSirketler.forEach((element) => {
        if (this.credentials.MuhasebeSirketNo == element.CompanyID) {
          this.parameters.CurrentAccountCompanyCode =
            element.CurrentAccountCompanyCode;
        }
      });
      this.currenctCompanies = this.credentials.Sirketler;

      this.LoadParameters();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          } 
        });
    }
  },
  components: {
    tarihim,
    yetkidialog,
    snackbarcomp,
    loadingcomp,
  },
};
</script>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>